// extracted by mini-css-extract-plugin
export default {"container":"vE-z","title":"wE-z","link":"xE-z"};